import React from 'react';
import { stats } from '../../data/content';
export function StatsBar() {
  return <section aria-label="Resultados del sistema" className="w-full bg-white px-4 py-8 sm:px-6 sm:py-10" data-id="element-306" data-mp="1j8ma64pvky1q">
      <dl className="mx-auto grid w-full max-w-content grid-cols-2 gap-y-6 sm:grid-cols-4 sm:gap-y-0" data-id="element-307" data-mp="1o7fep7n6pepr">
        {stats.map((stat, i) => <div key={stat.label} className={`px-2 text-center ${i % 2 === 1 ? 'border-l border-navy/10' : ''} sm:border-l sm:first:border-l-0`} data-id="element-308" data-mp="1t08jtwmkep2d" data-mpi={i}>
            <dt className="sr-only" data-id="element-309" data-mp="21xiupgvh0c6r">{stat.label}</dt>
            <dd data-id="element-310" data-mp="26xx698wa649j">
              <span className="block font-serif text-[26px] font-extrabold leading-none tracking-tight text-navy sm:text-4xl" data-id="element-311" data-mp="26zi0syilhn7e">
                {stat.value}
              </span>
              <span className="mt-1.5 block text-[10.5px] font-bold uppercase tracking-[0.12em] text-navy/50 sm:text-[11px]" data-id="element-312" data-mp="ckyvko6o55lo">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </section>;
}